import { render } from "./AddSchoolrondeView.vue?vue&type=template&id=94f670fc&scoped=true"
import script from "./AddSchoolrondeView.vue?vue&type=script&lang=js"
export * from "./AddSchoolrondeView.vue?vue&type=script&lang=js"

import "./AddSchoolrondeView.vue?vue&type=style&index=0&id=94f670fc&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94f670fc"]])

export default __exports__